import gql from 'graphql-tag';

export default gql`
  query mySummaryQuery($refetch: Boolean) {
    viewer {
      id
      loyaltyId
      firstName
      lastName
      loyalty(refetch: $refetch) {
        status
        total
        pointsValue
      }
      isLoyaltyCardLinked
    }
  }
`;
